import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  dragAndDropWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '214px',
    border: '1px dashed #6C59E6',
    backgroundColor: '#F7F5FF',
    borderRadius: '8px',
    cursor: 'pointer',
  },
}));
